import script from "./MemberProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberProfileView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__